// extracted by mini-css-extract-plugin
export default {"button":"Button_button__N289O","small":"Button_small__maEKX","text":"Button_text__OgRWg","error":"Button_error__jT86x","negative":"Button_negative__zGZO7"};